export interface LoginResponse {
  accessToken: string
}

export interface TwoFactorChallengeResponse {
  twoFactorRequired: true
  challengeToken: string
}

/**
 * Admin portal logins stop at a two-factor challenge - the session token only arrives once the one-time pin
 * has been verified.
 */
export type LoginResult = LoginResponse | TwoFactorChallengeResponse

export const isTwoFactorChallenge = (result: LoginResult): result is TwoFactorChallengeResponse => {
  return (result as TwoFactorChallengeResponse).twoFactorRequired === true
}

export interface AuthenticationCheck {
  isAuthenticated: boolean
}
